import { Form, DatePicker, Image, Typography } from 'antd'
import DatePickerIcon from '../../assets/icons/datepicker-calendar.svg'
import './CustomDatePicker.scss'

const { Text } = Typography;

const CustomDatePicker = ({ label, name, rules, placeholder, isRequired, ...rest }) => {
    return (
        <Form.Item
            label={label &&
                <Text>
                    {label}
                    {isRequired && <Text type="danger"> *</Text>}
                </Text>
            }
            name={name}
            rules={rules}
            className="custom-date-picker-form-item"
        >
            <DatePicker
                format="DD/MM/YYYY"
                placeholder={placeholder}
                className='custom-date-picker'
                suffixIcon={<Image src={DatePickerIcon} preview={false} />}
                {...rest}
            />
        </Form.Item>
    )
}

export default CustomDatePicker